import { inject, Injectable } from '@angular/core'
import { signalPersistence } from '@mos/client/shared/storage/signal-persistence'
import { StorageStrategy } from '@mos/client/shared/storage/strategies/storage.strategy'
import { createEntitySignalStore } from '@mos/client/shared/utils'

interface ModalHistory {
	id: string
	date: Date
}

interface PersistedModalHistory {
	ids: string[]
	entities: Record<string, ModalHistory>
}

@Injectable({ providedIn: 'root' })
export class ModalHistoryRepository {
	readonly storageStrategy = inject(StorageStrategy)
	private readonly store = createEntitySignalStore<ModalHistory, string>()

	constructor() {
		signalPersistence<PersistedModalHistory>({
			key: 'mos-modal-history',
			storage: this.storageStrategy,
			read: () => {
				const items = this.store.getAll()
				return {
					ids: items.map((item) => item.id),
					entities: Object.fromEntries(items.map((item) => [item.id, item])),
				}
			},
			write: (stored) => {
				this.store.set((stored.ids ?? []).map((id) => stored.entities[id]).filter((item) => !!item))
			},
		})
	}

	getModal(id: string) {
		return this.store.get(id)
	}

	hasModal(id: string) {
		return this.store.has(id)
	}

	logModal(id: string) {
		this.store.upsert({ id, date: new Date() })
	}

	forgetModal(id: string) {
		this.store.remove(id)
	}
}
